import {MainVideoState} from "../definitions/MainVideoState";
import {PayloadAction} from "@reduxjs/toolkit";
import GpsRecord from "../../../data-structures/GpsRecord";
import {buildFastLookup} from "../helpers/BuildFastLookup";

export const gpsDataLoaded = (state: MainVideoState, action: PayloadAction<GpsRecord[]>) => {
    state.locationState.frameToGpsFast = buildFastLookup(action.payload);
    state.locationState.nearestGps = state.locationState.frameToGpsFast.get(state.currentFrame);
};
